document.addEventListener('DOMContentLoaded', () => {
  const scrollToElement = (element) => element?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  const promotionEnds = Date.parse('2026-10-16T00:00:00-06:00');
  const promotionActive = () => Date.now() >= Date.parse('2026-09-20T00:00:00-06:00') && Date.now() < promotionEnds;
  const expirePromotion = () => {
    if (promotionActive()) return;
    document.querySelectorAll('[data-early-bird-promo], [data-early-bird-cart]').forEach(node => { node.hidden = true; });
  };
  expirePromotion();
  if (document.querySelector('[data-early-bird-promo]') && promotionActive()) {
    window.setTimeout(expirePromotion, Math.min(promotionEnds - Date.now() + 100, 2147483647));
  }
  window.addEventListener('pageshow', expirePromotion);
  document.querySelectorAll('[data-purchase-scroll]').forEach(link => link.addEventListener('click', event => {
    const target = document.getElementById('ThermStridePurchase');
    if (target) { event.preventDefault(); scrollToElement(target.querySelector('form') || target); target.querySelector('[data-option-value]')?.focus({ preventScroll:true }); }
  }));

  // Read the single original Customer Reviews section. Summaries are text excerpts, not another widget.
  const connectReviews = () => {
    const reviews=document.querySelector('.ts-reviews--masonry[id]');
    if(!reviews) return;
    const entries=[...reviews.querySelectorAll('.ts-review[data-review-rating]')];
    const ratings=entries.map(node=>Number(node.dataset.reviewRating)).filter(value=>value>=1&&value<=5);
    const average=ratings.length ? ratings.reduce((sum,value)=>sum+value,0)/ratings.length : null;
    let slots=[...document.querySelectorAll('[data-review-rating-slot]')];
    if(!slots.length){const price=document.querySelector('[data-product-price]');if(price){let slot=price.querySelector('[data-existing-reviews-link]');if(!slot){slot=document.createElement('span');slot.dataset.existingReviewsLink='';price.append(slot);}slots=[slot];}}
    slots.forEach(slot=>{
      slot.replaceChildren();if(!average)return;
      const link=document.createElement('a');link.className='early-bird-rating';link.href='#'+reviews.id;
      const stars=document.createElement('span');stars.className='early-bird-stars';stars.setAttribute('aria-hidden','true');stars.textContent='★'.repeat(Math.round(average))+'☆'.repeat(5-Math.round(average));
      link.append(stars,document.createTextNode(average.toFixed(1)+' · '+entries.length+' Reviews'));
      link.setAttribute('aria-label',average.toFixed(1)+' out of 5 from '+ratings.length+' rated reviews; '+entries.length+' customer reviews.');
      link.addEventListener('click',event=>{event.preventDefault();scrollToElement(reviews);const heading=reviews.querySelector('h2');heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true});});slot.append(link);
    });
    const preview=document.querySelector('[data-review-preview]');
    if(!preview)return;
    const cards=preview.querySelector('[data-review-preview-cards]');cards.replaceChildren();
    const ranked=entries.map((entry,index)=>({entry,index,score:(entry.querySelector('.ts-review__photo img')?10:0)+(/rid|fish|football|outdoor|cold morning|layer/i.test(entry.textContent)?5:0)})).sort((a,b)=>b.score-a.score||a.index-b.index).slice(0,3);
    ranked.forEach(({entry})=>{
      const body=entry.querySelector('.ts-review__expand .ts-review__body, .ts-review__content > .ts-review__body');
      if(!body)return;
      const card=document.createElement('article');card.className='ds-review-card';
      const image=entry.querySelector('.ts-review__photo img');if(image){const copy=image.cloneNode();copy.removeAttribute('id');copy.loading='lazy';copy.sizes='(max-width:620px) calc(100vw - 36px), 30vw';card.append(copy);}
      const quote=document.createElement('blockquote');const text=body.textContent.trim();quote.textContent=text.length>260?text.slice(0,257)+'…':text;
      const author=document.createElement('cite');author.textContent=entry.querySelector('.ts-review__author')?.textContent.trim() || '';
      card.append(quote,author);cards.append(card);
    });
    preview.hidden=!cards.children.length;
    const all=preview.querySelector('[data-all-reviews-link]');all.href='#'+reviews.id;
    if(!all.dataset.bound){all.dataset.bound='true';all.addEventListener('click',event=>{event.preventDefault();scrollToElement(document.querySelector('.ts-reviews--masonry[id]'));});}
  };
  connectReviews();
  document.addEventListener('shopify:section:load',connectReviews);
  document.addEventListener('shopify:section:unload',()=>window.setTimeout(connectReviews,0));
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !menuButton) return;
    menu.hidden = !open;
    menuButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };

  menuButton?.addEventListener('click', () => setMenu(true));
  menuClose?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  document.querySelectorAll('[data-mega-item]').forEach((item) => {
    const trigger = item.querySelector('[data-mega-trigger]');
    const setMegaMenu = (open) => {
      item.classList.toggle('is-open', open);
      trigger?.setAttribute('aria-expanded', String(open));
    };

    item.addEventListener('mouseenter', () => setMegaMenu(true));
    item.addEventListener('mouseleave', () => setMegaMenu(false));
    item.addEventListener('focusin', () => setMegaMenu(true));
    trigger?.addEventListener('click', () => setMegaMenu(true));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setMegaMenu(false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mega-item].is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
    });
  });

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('[data-faq-item]');
      const wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('[data-faq-item]').forEach((row) => {
        row.classList.remove('is-open');
        row.querySelector('[data-faq-button]').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        const video=gallery.querySelector('[data-hero-video]');if(video){video.hidden=true;video.querySelector('video')?.pause();}
        main.hidden=false;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const picker = form.querySelector('[data-variant-picker]');
    const variantSelect = form.querySelector('.variant-select');
    const variantsNode = form.querySelector('[data-product-variants]');
    if (!picker || !variantSelect || !variantsNode) return;

    const variants = JSON.parse(variantsNode.textContent);
    const productInfo = form.closest('[data-product-info]');
    const currentPrice = productInfo?.querySelector('[data-product-current-price]');
    const comparePrice = productInfo?.querySelector('[data-product-compare-price]');
    const priceSaving = productInfo?.querySelector('[data-product-price-saving]');
    const sale = productInfo?.querySelector('[data-product-sale]');
    const saleMessage = productInfo?.querySelector('[data-product-sale-message]');
    const offerSaving = productInfo?.querySelector('[data-product-offer-saving]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addLabel = addButton?.querySelector('[data-add-label]');
    const defaultAddLabel = addButton?.dataset.addDefaultLabel || 'Add to bag';
    const stickyBar = document.querySelector('[data-sticky-product-bar]');
    const stickyPrice = stickyBar?.querySelector('[data-sticky-price]');
    const stickyButton = stickyBar?.querySelector('[data-sticky-add]');

    const optionGroups = [...picker.querySelectorAll('[data-option-position]')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    picker.querySelector('[data-bundle-group]')?.style.setProperty('order', '-1');
    const sizeGroup = picker.querySelector('[data-size-group]');
    let sizeConfirmed = !sizeGroup || Boolean(new URL(window.location.href).searchParams.get('variant'));
    const isVest = Boolean(form.closest('.main-product--heated-vest-cro')); 
    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value || '');
    const optionForVariant = (variant) => [...variantSelect.options].find((option) => option.value === String(variant?.id));

    const updateBundleCards = (selected) => {
      const bundleGroup = picker.querySelector('[data-bundle-group]');
      if (!bundleGroup) return;
      const bundleIndex = Number(bundleGroup.dataset.optionPosition) - 1;

      bundleGroup.querySelectorAll('[data-bundle-option]').forEach((input) => {
        const candidateOptions = [...selected];
        candidateOptions[bundleIndex] = input.value;
        const candidate = variants.find((variant) => variant.options.every((value, index) => value === candidateOptions[index]));
        const candidateOption = optionForVariant(candidate);
        const card = input.nextElementSibling;
        if (!card || !candidateOption) return;

        const cardPrice = card.querySelector('[data-bundle-price]');
        const cardCompare = card.querySelector('[data-bundle-compare]');
        const cardSaving = card.querySelector('[data-bundle-saving]');
        const hasSale = Boolean(candidateOption.dataset.comparePrice && candidateOption.dataset.savingAmount);
        const upgradeNote = card.querySelector('[data-bundle-upgrade]');
        if (upgradeNote) {
          const everyday = variants.find((variant) => variant.available && variant.options.every((value, index) =>
            index === bundleIndex ? value.replace(/[\s,]/g, '').includes('10000') : value === selected[index]
          ));
          const difference = everyday ? candidate.price - everyday.price : 0;
          upgradeNote.hidden = !candidate.available || !everyday || difference <= 0;
          upgradeNote.textContent = '';
          if (!upgradeNote.hidden) {
            const currency = window.Shopify?.currency?.active || 'USD';
            const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(difference / 100);
            upgradeNote.textContent = `Only +${amount}`;
          }
        }
        if (cardPrice) cardPrice.textContent = candidateOption.dataset.price || '';
        if (cardCompare) {
          cardCompare.textContent = hasSale ? candidateOption.dataset.comparePrice : '';
          cardCompare.hidden = !hasSale;
        }
        if (cardSaving) {
          cardSaving.textContent = hasSale ? `Save ${candidateOption.dataset.savingAmount}` : '';
          cardSaving.hidden = !hasSale;
        }
      });
    };

    const selectVariant = (variant) => {
      if (!variant) return;
      variantSelect.value = String(variant.id);

      optionGroups.forEach((group, index) => {
        const input = [...group.querySelectorAll('[data-option-value]')].find((item) => item.value === variant.options[index]);
        if (input) input.checked = true;
      });

      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const batteryValue = variant.options.find(value => /battery/i.test(value)) || '';
      const batteryKey = batteryValue.replace(/[\s,]/g, '').toLowerCase();
      const batteryLabel = batteryKey.includes('20000') ? '20,000mAh Battery Included' : batteryKey.includes('10000') ? '10,000mAh Battery Included' : 'Vest Only — No Battery Included';
      const selectionSummary = productInfo?.querySelector('[data-purchase-selection]');
      if (selectionSummary) selectionSummary.textContent = `${selectedOption?.dataset.price || ''} — ${batteryLabel}`;
      const stickySelection = stickyBar?.querySelector('[data-sticky-selection]');
      const selectedSize = sizeGroup ? variant.options[Number(sizeGroup.dataset.optionPosition) - 1] : '';
      if (stickySelection) stickySelection.textContent = `${sizeConfirmed ? selectedSize : 'Choose size'} · ${batteryKey.includes('20000') ? '20,000mAh' : batteryKey.includes('10000') ? '10,000mAh' : 'No battery'}`;
      if (selectedOption) {
        const hasSale = Boolean(selectedOption.dataset.comparePrice && selectedOption.dataset.savingAmount);
        if (currentPrice) currentPrice.textContent = selectedOption.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = hasSale ? selectedOption.dataset.comparePrice : '';
          comparePrice.hidden = !hasSale;
        }
        if (priceSaving) {
          priceSaving.textContent = hasSale ? `SAVE ${selectedOption.dataset.savingAmount}` : '';
          priceSaving.hidden = !hasSale;
        }
        sale?.classList.toggle('is-hidden', !hasSale);
        saleMessage?.classList.toggle('is-hidden', !hasSale);
        if (offerSaving) offerSaving.textContent = hasSale ? `Save ${selectedOption.dataset.savingAmount} Today` : '';
      }

      if (addButton && addLabel) {
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? (isVest ? 'ADD TO CART — ' + (selectedOption?.dataset.price || '') : defaultAddLabel) : 'Sold out';
      }

      if (stickyBar && stickyButton) {
        if (stickyPrice) stickyPrice.textContent = selectedOption?.dataset.price || '';
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      }

      if (selectedOption?.dataset.mediaSrc) {
        const mainImage = document.querySelector('[data-product-gallery] [data-gallery-main]');
        if (mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = selectedOption.dataset.mediaSrc;
          mainImage.alt = selectedOption.dataset.mediaAlt || '';
        }
      }

      if (!isVest || sizeConfirmed) {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', nextUrl);
      }
      updateBundleCards(variant.options);
      if(isVest){
        document.querySelectorAll('[data-sales-price]').forEach(node=>{node.textContent=selectedOption?.dataset.price || '';});
        document.querySelectorAll('[data-sales-compare]').forEach(node=>{node.textContent=selectedOption?.dataset.comparePrice || '';node.hidden=!selectedOption?.dataset.comparePrice;});
        const upgrade=productInfo.querySelector('[data-bundle-upgrade]');
        document.querySelectorAll('[data-upgrade-difference]').forEach(node=>{node.hidden=!upgrade||upgrade.hidden;node.textContent=upgrade?.textContent.toUpperCase()||'';});
        const upgradeInput=[...picker.querySelectorAll('[data-bundle-option]')].find(input=>input.value.replace(/[\s,]/g,'').includes('20000'));
        const bundleIndex=Number(picker.querySelector('[data-bundle-group]')?.dataset.optionPosition)-1;
        const target=variants.find(item=>item.available&&item.options.every((value,index)=>index===bundleIndex?value===upgradeInput?.value:value===variant.options[index]));
        document.querySelectorAll('[data-upgrade-battery]').forEach(button=>{button.disabled=!target;button.textContent=target?'UPGRADE TO 20,000mAh':'20,000mAh UNAVAILABLE IN THIS SIZE';});
      }
    };

    const refreshAvailability = () => {
      const selected = selectedOptions();
      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach((input) => {
          const available = variants.some((variant) => {
            if (!variant.available || variant.options[index] !== input.value) return false;
            // Battery choices remain available across sizes; keep impossible same-size combinations explicit.
            return variant.options.every((value, otherIndex) => otherIndex === index || !selected[otherIndex] || value === selected[otherIndex]);
          });
          input.disabled = !available;
          input.nextElementSibling?.classList.toggle('is-unavailable', !available);
        });
      });
    };

    picker.addEventListener('change', (event) => {
      const changedInput = event.target.closest('[data-option-value]');
      if (!changedInput) return;

      if (changedInput.closest('[data-size-group]')) sizeConfirmed = true;
      let selected = selectedOptions();
      if (!sizeConfirmed && sizeGroup) {
        const sizeIndex = Number(sizeGroup.dataset.optionPosition)-1;
        selected[sizeIndex] = variants.find(item => String(item.id) === variantSelect.value)?.options[sizeIndex] || '';
      }
      let variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));

      // Do not silently substitute a different size or battery for an unavailable choice.
      if (variant) selectVariant(variant);
      else {
        variantSelect.value = '';
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stickyButton) { stickyButton.disabled = true; stickyButton.textContent = 'Unavailable'; }
      }
      refreshAvailability();
      if (isVest && !sizeConfirmed) sizeGroup?.querySelectorAll('[data-option-value]').forEach(input => { input.checked=false; });
    });

    if(isVest)document.querySelectorAll('[data-upgrade-battery]').forEach(button=>button.addEventListener('click',()=>{
      const input=[...picker.querySelectorAll('[data-bundle-option]')].find(item=>item.value.replace(/[\s,]/g,'').includes('20000'));
      if(!input||input.disabled)return;
      input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));
      scrollToElement(sizeConfirmed?form:(sizeGroup||picker));
      (sizeGroup||picker).querySelector('[data-option-value]:not([disabled])')?.focus({preventScroll:true});
    }));
    form.addEventListener('submit', event => {
      if (!isVest) return;
      const complete = optionGroups.every(group => group.querySelector('[data-option-value]:checked'));
      const variant = variants.find(item => String(item.id) === variantSelect.value);
      if (!complete || !sizeConfirmed || !variant?.available) {
        event.preventDefault(); event.stopImmediatePropagation();
        const error = form.querySelector('[data-product-form-error]');
        if (error) { error.textContent = !sizeConfirmed || !complete ? 'Please choose your size before adding to cart.' : 'This combination is unavailable. Please choose another option.'; error.hidden=false; }
        scrollToElement(sizeGroup || picker);
        (sizeGroup || picker).querySelector('[data-option-value]:not([disabled])')?.focus({preventScroll:true});
      }
    }, true);
    // Click also acknowledges the initially checked size without forcing a different size.
    sizeGroup?.addEventListener('click', event => { if(event.target.matches('input, label')) sizeConfirmed=true; });

    refreshAvailability();
    const initialVariant = variants.find((variant) => String(variant.id) === variantSelect.value);
    if (initialVariant) {
      selectVariant(initialVariant);
      updateBundleCards(initialVariant.options);
      if (isVest && !sizeConfirmed) sizeGroup?.querySelectorAll('[data-option-value]').forEach(input => { input.checked=false; });
    }

    if (stickyBar && stickyButton && addButton) {
      const updateStickyVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 620px)').matches;
        const hasPassedPrimaryCta = addButton.getBoundingClientRect().bottom < 0;
        stickyBar.hidden = !(isMobile && hasPassedPrimaryCta);
      };

      stickyButton.addEventListener('click', () => {
        const hasCompleteSelection = sizeConfirmed && optionGroups.every((group) => group.querySelector('[data-option-value]:checked'));
        if (!hasCompleteSelection) {
          scrollToElement(sizeGroup || picker);
          (sizeGroup || picker).querySelector('[data-option-value]:not([disabled])')?.focus({preventScroll:true});
          return;
        }
        if (addButton.disabled) {
          addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        form.requestSubmit(addButton);
      });

      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();
    }

    const syncVariantFromUrl = () => {
      const variantId = new URL(window.location.href).searchParams.get('variant');
      const variant = variants.find((item) => String(item.id) === variantId);
      if (!variant) return;
      sizeConfirmed = true;
      selectVariant(variant);
      refreshAvailability();
    };
    window.addEventListener('popstate', syncVariantFromUrl);
    window.addEventListener('pageshow', syncVariantFromUrl);
  });

  document.querySelectorAll('[data-size-guide-dialog]').forEach((dialog) => {
    dialog.querySelector('[data-vest-units]')?.addEventListener('change', event => {
      const unit = event.target.value;
      dialog.querySelectorAll('[data-measurement-cm]').forEach(cell => {
        const cm = Number(cell.dataset.measurementCm);
        cell.textContent = unit === 'cm' ? String(cm) : (Math.round(cm / 2.54 * 10) / 10).toFixed(1);
      });
      dialog.querySelector('[data-vest-unit-label]').textContent = unit;
    });
    const trigger = document.querySelector(`[data-size-guide-open][aria-controls="${dialog.id}"]`);
    if (!trigger || typeof dialog.showModal !== 'function') return;

    trigger.addEventListener('click', () => dialog.showModal());
    dialog.querySelectorAll('[data-size-guide-close]').forEach((button) => {
      button.addEventListener('click', () => dialog.close());
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus());
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const drawerPanel = drawer.querySelector('.cart-drawer__panel');
  const drawerItems = drawer.querySelector('[data-cart-drawer-items]');
  const drawerEmpty = drawer.querySelector('[data-cart-drawer-empty]');
  const drawerFooter = drawer.querySelector('[data-cart-drawer-footer]');
  const drawerTotal = drawer.querySelector('[data-cart-drawer-total]');
  const drawerCount = drawer.querySelector('[data-cart-drawer-count]');
  const drawerStatus = drawer.querySelector('[data-cart-drawer-status]');
  const rootUrl = window.Shopify?.routes?.root || '/';
  let activeBeforeDrawer = null;
  let currentCurrency = window.Shopify?.currency?.active || 'USD';
  let configuredUpdateCart = null;
  let activeProductForm = null;
  let mutationInFlight = false;

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const formatMoney = (cents, currency = currentCurrency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  const setStatus = (message = '') => {
    if (drawerStatus) drawerStatus.textContent = message;
  };

  const setBusy = (busy) => {
    drawer.classList.toggle('is-busy', busy);
    drawer.setAttribute('aria-busy', String(busy));
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.hidden = count === 0;
    });
    if (drawerCount) drawerCount.textContent = `(${count})`;
  };

  const itemMarkup = (item) => {
    const image = item.featured_image?.url || item.image;
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__variant">${escapeHtml(item.variant_title)}</p>`
      : '';
    const batteryWarning = item.handle === 'thermstride-dual-control-heated-vest' && /vest only/i.test(item.variant_title || '')
      ? '<p class="cart-drawer__battery-warning">Battery NOT Included</p>'
      : '';
    const comparePrice = item.original_line_price > item.final_line_price
      ? `<s>${formatMoney(item.original_line_price)}</s>`
      : '';
    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.featured_image?.alt || item.product_title)}" width="184" height="224" loading="lazy">`
      : '';

    return `
      <article class="cart-drawer__item" data-cart-line="${escapeHtml(item.key)}">
        <a class="cart-drawer__image" href="${escapeHtml(item.url)}">${imageMarkup}</a>
        <div class="cart-drawer__item-main">
          <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${variant}
          ${batteryWarning}
          <p class="cart-drawer__price">${formatMoney(item.final_line_price)}${comparePrice}</p>
          <div class="cart-drawer__item-actions">
            <div class="cart-drawer__quantity" aria-label="Quantity for ${escapeHtml(item.product_title)}">
              <button type="button" data-cart-change="decrease" data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="Decrease quantity">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-cart-change="increase" data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="Increase quantity">+</button>
            </div>
            <button class="cart-drawer__remove" type="button" data-cart-change="remove" data-line-key="${escapeHtml(item.key)}">Remove</button>
          </div>
        </div>
      </article>`;
  };

  const renderCart = (cart) => {
    currentCurrency = cart.currency || currentCurrency;
    updateCartCount(cart.item_count);
    if (drawerItems) drawerItems.innerHTML = cart.items.map(itemMarkup).join('');
    if (drawerEmpty) drawerEmpty.hidden = cart.item_count > 0;
    if (drawerFooter) drawerFooter.hidden = cart.item_count === 0;
    if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
    renderEarlyBird(cart);
  };

  const offer = drawer.querySelector('[data-early-bird-cart]');
  const offerCopy = offer?.querySelector('[data-early-bird-cart-copy]');
  const secondPicker = offer?.querySelector('[data-second-vest-picker]');
  const secondOpen = offer?.querySelector('[data-second-vest-open]');
  const secondAdd = offer?.querySelector('[data-second-vest-add]');
  const secondError = offer?.querySelector('[data-second-vest-error]');
  const vestHandle = 'thermstride-dual-control-heated-vest';
  let secondProduct = null;
  let secondVariant = null;
  const renderEarlyBird = cart => {
    if (!offer || !offerCopy) return;
    const eligible = cart.items.filter(item => item.handle === vestHandle && !item.selling_plan_allocation);
    const count = eligible.reduce((sum,item) => sum + item.quantity, 0);
    offer.hidden = !promotionActive() || count === 0;
    if (offer.hidden) return;
    const title = offer.dataset.discountTitle;
    // Ajax line allocations are already extended amounts; do not multiply by quantity.
    const saved = eligible.reduce((sum,item) => sum + (item.line_level_discount_allocations || []).reduce((amount,allocation) =>
      amount + (allocation.discount_application?.title === title ? Number(allocation.amount || 0) : 0), 0), 0);
    if (count === 1) {
      offerCopy.innerHTML = '<p class="early-bird-kicker">🔥 UNLOCK YOUR EARLY BIRD DEAL</p><h3>Get Your 2nd Vest 50% OFF</h3><p>Add one more eligible ThermStride Heated Vest to unlock <strong>50% OFF your second vest</strong>.</p>' + (offer.dataset.dailyLimit === 'true' ? '<p>First 20 qualifying orders daily · Ends Oct 15</p>' : '<p>Ends Oct 15</p>');
    } else if (saved > 0) {
      offerCopy.innerHTML = '<p class="early-bird-kicker">🎉 EARLY BIRD DEAL UNLOCKED</p><h3>You saved 50% on your second vest.</h3><p class="early-bird-savings">Early Bird Savings: −' + escapeHtml(formatMoney(saved)) + '</p>';
    } else {
      offerCopy.innerHTML = '<h3>Your two vests are in the bag.</h3><p>The Early Bird discount has not been applied to this cart. Check your discount at checkout or contact us before paying.</p>';
    }
    secondOpen.hidden = count !== 1;
    if (count !== 1) { secondPicker.hidden=true; secondOpen.setAttribute('aria-expanded','false'); }
  };
  const updateSecondSelection = () => {
    const selections = [...secondPicker.querySelectorAll('select')].map(select => select.value);
    secondVariant = secondProduct?.variants.find(variant => variant.options.every((value,index) => value === selections[index]));
    secondAdd.disabled = mutationInFlight || !secondVariant?.available;
    secondAdd.textContent = secondVariant && !secondVariant.available ? 'SOLD OUT' : 'ADD TO CART';
    secondPicker.querySelector('[data-second-vest-price]').textContent = secondVariant ? formatMoney(secondVariant.price) + (secondVariant.available ? '' : ' · Sold out') : 'Choose both options to see the price.';
  };
  secondOpen?.addEventListener('click', async () => {
    if (!secondPicker.hidden) { secondPicker.hidden=true; secondOpen.setAttribute('aria-expanded','false'); return; }
    secondOpen.disabled=true;
    secondError.hidden=true;
    try {
      if (!secondProduct) {
        const response = await fetch(rootUrl + 'products/' + vestHandle + '.js', {headers:{Accept:'application/json'}});
        if(!response.ok) throw Error('Options could not be loaded. Please try again.');
        secondProduct = await response.json();
        const options = secondPicker.querySelector('[data-second-vest-options]');
        options.innerHTML = secondProduct.options.map((option,index) => '<label for="SecondVestOption-' + index + '">' + escapeHtml(option.name) + '</label><select id="SecondVestOption-' + index + '" required><option value="">Choose ' + escapeHtml(option.name.toLowerCase()) + '</option>' + option.values.map(value => '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>').join('') + '</select>').join('');
        options.addEventListener('change',updateSecondSelection);
      }
      secondPicker.hidden=false; secondOpen.setAttribute('aria-expanded','true');
      updateSecondSelection(); secondPicker.querySelector('select')?.focus();
    } catch(error) {
      secondPicker.hidden=false; secondError.textContent=error.message; secondError.hidden=false;
    } finally { secondOpen.disabled=false; }
  });
  secondAdd?.addEventListener('click', async () => {
    if(mutationInFlight || !secondVariant?.available || !promotionActive()) return;
    mutationInFlight=true; secondAdd.disabled=true; secondError.hidden=true; setBusy(true);
    let added=false;
    try {
      // Reuse the theme's existing add pipeline and Shopify standard cart action.
      const form=document.createElement('form');
      const input=document.createElement('input');input.name='id';input.value=secondVariant.id;form.append(input);
      await addProductWithShopify(form); added=true;
      renderCart(await getCart());setStatus('Second vest added to your bag.');
      drawer.querySelector('.cart-drawer__body')?.scrollTo({top:0});
      secondPicker.querySelectorAll('select').forEach(select=>{select.value='';});secondVariant=null;
    } catch(error) {
      secondError.textContent = added ? 'Your vest was added, but the bag could not refresh. Reopen your bag before adding again.' : error.message;
      secondError.hidden=false;
    } finally {mutationInFlight=false;setBusy(false);updateSecondSelection();}
  });

  const getCart = async () => {
    const response = await fetch(`${rootUrl}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Your bag could not be loaded. Please try again.');
    return response.json();
  };

  const productFormCartLine = (form) => {
    const formData = new FormData(form);
    const merchandiseId = String(formData.get('id') || '');
    const quantity = Math.max(1, Number.parseInt(String(formData.get('quantity') || '1'), 10) || 1);
    const attributes = [];

    formData.forEach((value, key) => {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);
      if (!propertyMatch || typeof value !== 'string' || value === '') return;
      attributes.push({ key: propertyMatch[1], value });
    });

    const line = { merchandiseId, quantity };
    if (attributes.length) line.attributes = attributes;
    const sellingPlanId = formData.get('selling_plan');
    if (sellingPlanId) line.sellingPlanId = String(sellingPlanId);
    return line;
  };

  const getConfiguredUpdateCart = () => {
    const updateCart = window.Shopify?.actions?.updateCart;
    if (typeof updateCart !== 'function' || typeof updateCart.configure !== 'function') return null;
    if (configuredUpdateCart === updateCart) return updateCart;

    updateCart.configure({
      eventTarget: (meta) => {
        if (meta?.type === 'shopify:cart:lines-update' && meta?.action === 'add') {
          return activeProductForm || document.querySelector('[data-product-form]') || drawer;
        }
        return drawer;
      },
      async handler(defaultHandler) {
        // Run Shopify's mutation exactly once. The product-form submit handler
        // below owns the custom drawer refresh/open animation after success.
        return defaultHandler();
      },
    });

    configuredUpdateCart = updateCart;
    return updateCart;
  };

  const addProductWithShopify = async (form) => {
    const line = productFormCartLine(form);
    if (!line.merchandiseId) throw new Error('Please select a product option.');

    const updateCart = getConfiguredUpdateCart();
    if (!updateCart) {
      // Compatibility fallback for storefronts where Standard Actions have not
      // loaded. This preserves the drawer instead of allowing a page redirect.
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');
      return result;
    }

    activeProductForm = form;
    let result;
    try {
      result = await updateCart(
        { lines: [line] },
        { event: { context: 'product', detail: { source: 'thermstride-product-form' } } }
      );
    } finally {
      activeProductForm = null;
    }

    if (result?.userErrors?.length) {
      throw new Error(result.userErrors[0].message || 'This item could not be added.');
    }
    return result;
  };

  const refreshCart = async () => {
    setBusy(true);
    try {
      const cart = await getCart();
      renderCart(cart);
      return cart;
    } finally {
      setBusy(false);
    }
  };

  const openDrawer = async ({ refresh = true } = {}) => {
    activeBeforeDrawer = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    setStatus('');
    if (refresh) {
      try {
        await refreshCart();
      } catch (error) {
        setStatus(error.message);
      }
    }
    drawer.querySelector('.cart-drawer__body')?.scrollTo({top:0});
    window.setTimeout(() => drawer.querySelector('.cart-drawer__close')?.focus(), 30);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (activeBeforeDrawer instanceof HTMLElement) activeBeforeDrawer.focus();
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  drawer.querySelector('.cart-drawer__checkout')?.addEventListener('click', event => {
    if (mutationInFlight) { event.preventDefault(); setStatus('Please wait while your bag updates.'); }
  });

  drawerPanel?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...drawerPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  drawerItems?.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-change]');
    if (!control || mutationInFlight) return;
    mutationInFlight = true;
    const key = control.dataset.lineKey;
    const currentQuantity = Number(control.dataset.quantity || 0);
    const action = control.dataset.cartChange;
    const quantity = action === 'increase' ? currentQuantity + 1 : action === 'decrease' ? Math.max(0, currentQuantity - 1) : 0;
    setBusy(true);
    setStatus('');
    try {
      const response = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Your bag could not be updated.');
      renderCart(cart);
      setStatus(action === 'remove' || quantity === 0 ? 'Item removed.' : 'Quantity updated.');
    } catch (error) {
      setStatus(error.message);
    } finally {
      mutationInFlight = false;
      setBusy(false);
    }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!event.submitter?.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      const addButton = form.querySelector('[data-add-to-cart]');
      const addLabel = form.querySelector('[data-add-label]');
      const errorNode = form.querySelector('[data-product-form-error]');
      if (!addButton || addButton.disabled || mutationInFlight) return;
      mutationInFlight = true;
      setBusy(true);
      const pickerControls = [...form.querySelectorAll('[data-option-value]')];
      const disabledBefore = pickerControls.map(input=>input.disabled);
      pickerControls.forEach(input=>{input.disabled=true;});
      const stickyAdd = document.querySelector('[data-sticky-add]');
      if(stickyAdd) stickyAdd.disabled=true;
      let added=false;
      const originalLabel = addLabel?.textContent || 'Add to bag';
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding...';
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }

      try {
        await addProductWithShopify(form);
        added=true;
        const cart = await getCart();
        renderCart(cart);
        await openDrawer({ refresh: false });
        setStatus('Added to your bag.');
      } catch (error) {
        if (errorNode) {
          errorNode.textContent = added ? 'Your vest was added, but the bag could not refresh. Reopen your bag before adding again.' : error.message;
          errorNode.hidden = false;
        }
      } finally {
        mutationInFlight = false;
        setBusy(false);
        pickerControls.forEach((input,index)=>{input.disabled=disabledBefore[index];});
        if(stickyAdd) stickyAdd.disabled=false;
        addButton.disabled = false;
        if (addLabel) addLabel.textContent = originalLabel;
      }
    });
  });
});
